import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Button } from '@mui/material'
import { useNavigate } from "@reach/router"
import userStore from '../common/userStore'
import useTitle from '../../hooks/title'
import Header from '../header/Header'
import AuthHeader from '../layout/AuthHeader'
import classes from './VocalNetCommunity.module.scss'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import {ReactComponent as Affiliate} from '../../images/affiliate-black.svg'
import {ReactComponent as Windows} from '../../images/windows.svg'
import {ReactComponent as Mac} from '../../images/mac.svg'
import useWindowSize from '../../hooks/window-size';
import Footer from '../footer/Footer'
import clsx from 'clsx'
import Backdrop from '@mui/material/Backdrop';
import {createApi} from "../common/API";
import layoutStyles from '../layout/Layout.module.scss'
import { scroll } from '../../utils'
import { useLocation } from "@reach/router"


const showApp = createApi('/app/getApps', {method: 'POST', expandData: true, notify: true, noThrow: false});

const VocalNet = () => {
    useTitle("VocalNet Community - Transform voices in seconds with unlimited community support")
    const [version, setVersion] = useState('');
    const [price, setPrice] = useState('');
    const navigate = useNavigate();
    const windowSize = useWindowSize();
    const [isPlaying, setIsPlaying] = useState(false);
    const playerRef = useRef(null);

    const handlePlayClick = () => {
        if (windowSize.width < 500)
        setIsPlaying(true);
    };

    const handleOverlayClick = (e) => {
        
        // Check if the click occurred outside the iframe
        if (playerRef.current && !playerRef.current.contains(e.target)) {
            setIsPlaying(false);
        }
        if (isPlaying) 
            setIsPlaying(false);
    };
    const location = useLocation();
    useEffect(() => {
        //console.log('hash', window.location.hash)
        if (window.location.hash) {
            let dom = document.getElementById(window.location.hash.replace('#', ''));
            dom && dom.scrollIntoView({block:"center", behavior:"smooth"})
        } else {
            window.scrollTo(0, 0)
        }
        const fetchApiData = async () => {
            try {
              const response = await showApp();
              setVersion(response[4].version)
              setPrice(response[4].price)
            } catch (error) {
              console.error('Error fetching API data:', error);
            }
          };
        fetchApiData()
    }, [location.pathname])
    return <div className={clsx(classes.root, layoutStyles.root)}>
      {userStore.isAnonymous ? <Header black/> : <AuthHeader />}
      <Backdrop open={isPlaying} onClick={handleOverlayClick} />
        <div className={classes.banner}>
        {isPlaying && 
        <div className={classes.videoContainer}>
            <iframe src="https://www.youtube.com/embed/JvAU_GTQsDo?si=veIyymD16qJMRTXT?autoplay=1" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>}
            <div className={classes.title}>VocalNet{windowSize.width > 600 && " Community"}</div>
            <div className={classes.image} onClick={handlePlayClick} />
            <div className={classes.description}>AI-powered<br/>Voice Transformation Plugin<br/>Compatible with All DAWs<br/>Fully Offline</div>
            {/* {windowSize.width < 500 ?
            <div className={classes.description1}>AI-powered<br/>drum machine plugin<br/>with<br/>Infinite Sample Generation</div>:
             <React.Fragment>
            <div className={classes.description1}>AI-powered drum machine plugin with</div>
            <div className={classes.description2}>Infinite Sample Generation</div>
            </React.Fragment>} */}
        </div>
        <div className={classes.options} >
            <div className={clsx(classes.option, classes.green)}  style={windowSize.width < 500 ? {paddingLeft: 'calc(35vw + 2px)'} : {}}
                onClick = {() => document.getElementById("buys").scrollIntoView({block:"center", behavior:"smooth"})}>
                <ShoppingCartIcon/>
                <div className={classes.optionText} style={windowSize.width < 500 ? {marginLeft : 22} : {}}>Buy Now</div>
            </div>
            <div className={clsx(classes.option, classes.green)} style={windowSize.width < 500 ? {borderTop: '1.5px solid black', borderBottom: '1.5px solid black'} :
            {borderLeft: '1.5px solid black', borderRight: '1.5px solid black'}}
                onClick = {() => document.getElementById("downloads").scrollIntoView({block:"center", behavior:"smooth"})}
            >
                <SaveAltIcon style={{fontSize: 28}}/>
                <div className={classes.optionText}>{windowSize.width < 500 ? 'Download' : 'Download Free'}</div>
            </div>
            <a className={clsx(classes.option, classes.green)} style={{textDecoration: 'none'}} href="https://sessionloops.firstpromoter.com/"  target="_blank">
                <Affiliate style={{width: 27, height: 27}}/>
                <div className={classes.optionText}>{windowSize.width < 500 ? 'Affiliates' : 'Affiliate Program'}</div>
            </a>
        </div>
        <div className={classes.content}>
            <div className={classes.feature1}>
                <div className={classes.feature1Title}>How VocalNet works</div>
                <iframe className={classes.embedded} src="https://www.youtube.com/embed/JvAU_GTQsDo?si=veIyymD16qJMRTXT" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
            <div className={classes.mode}>
                <div className={classes.modeTitle}>Capture Mode</div>
                <div className={classes.modeDescription}>Record audio in real-time and<br/>Playback converted as audio effect</div>
                <div className={classes.modeImage} />
            </div>
            <div className={classes.mode}>
                <div className={classes.modeTitle}>File Mode</div>
                <div className={classes.modeDescription}>Load audio file directly and<br/> Drag & Drop converted to DAWs</div>
                <div className={clsx(classes.modeImage, classes.file)} />
            </div>
            <div className={classes.feature3}>
                <div className={classes.feature3Title}>Unlimted<br/> Open Community<br/> Support</div>
                <div className={classes.feature3Description}>Load free public models trained <br/> through <a href='https://github.com/RVC-Project/Retrieval-based-Voice-Conversion-WebUI/'>open-source project</a></div>
                {/* <div className={classes.feature3Title}>200 New Groundbreaking Presets</div>
                <div className={classes.feature3Description}>Get started with our collection of 200 brand-new hand-crafted presets. Explore drum sounds of House, Disco, R&B, Hip Hop and lots more  — all coming with individual layers.</div> */}
            </div>
            <div className={classes.free} />
            <div id="downloads" className={classes.downloads}>
                <div className={classes.download}>
                    <Button startIcon={<Windows style={{marginLeft: 7, marginRight: 7}}/>} variant="contained" className={classes.button}  href="https://storage.googleapis.com/sessionloops-bucket/VocalNetCommunity_Installer_CPU.exe" target="_blank">Download for Windows - CPU</Button>
                    Version 1.0.4, may be slow on clips longer than 30s
                </div>
                <div className={classes.download}>
                    <Button startIcon={<Windows style={{marginLeft: 7, marginRight: 7}}/>} variant="contained" className={classes.button}  href="https://storage.googleapis.com/sessionloops-bucket/VocalNetCommunity_Installer.exe" target="_blank">Download for Windows - GPU</Button>
                    Version 1.0.4, NVIDIA only, Minimum Driver 527.41
                </div>
                <div className={classes.download}>
                    <Button startIcon={<Mac style={{marginLeft: 7, marginRight: 10}}/>} variant="contained" className={classes.button}  href="https://storage.googleapis.com/sessionloops-bucket/VocalNetCommunity_Installer.zip" target="_blank">Download for Mac</Button>
                    Version 1.0.4, macOS 13+, Apple Silicon only
                </div>
            </div>
            <div className={classes.text}>You can try out all features for 14 days. Afterwards File Mode will be disabled.<br/>To access full version, purchase a lifetime license or subscribe to our plans. </div>
            <div id="buys" className={classes.buys}>
                <div className={classes.buy}>
                    <div className={classes.buyTitle}>One-time<br/>Purchase</div>
                    <div className={classes.buyPrice}>
                        ${price}
                        {/* <div className={classes.priceDiscount}>$29</div>
                        <div className={classes.priceSegment}/>
                        <div className={classes.priceNow}>$19</div>
                        <div className={classes.priceTag}>Introductory<br/>Price</div> */}
                    </div>
                    <div className={classes.buyDescription}>VocalNet and VocalNet Community only, pay once, use forever</div>
                    <Button style={{width: 193}} variant="contained" className={classes.button}  onClick={() => navigate('/account/app-buy?app-id=VocalNet')}>Buy VocalNet</Button>
                </div>
                <div className={classes.buy} style={{width: 361, marginLeft: windowSize.width < 500 ? 0 : 93}}>
                    <div className={classes.buyTitle}>Subscription<br/>( 14 days free trial )</div>
                    <div className={classes.buyPrice}>
                        <div style={{color: 'black'}} className={classes.priceSubscription}>Starts from</div>
                        <div style={{position: 'static', marginLeft: 10, marginRight: 30}} className={classes.priceNow}>$5.99</div>
                        <div className={classes.priceSubscription}>/ mo</div>
                    </div>
                    <div className={classes.buyDescription}>Everything in a bundle</div>
                    <Button style={{width: 193}} variant="contained" className={classes.button}  onClick={() => navigate('/pricing')}>See Plans</Button>
                </div>
                <div className={classes.buySegment1}/>
                <div className={classes.buySegment2}/>
            </div>
            {/* <div className={clsx(classes.mode, classes.nobackground)}>
                <div className={classes.modeTitle}>Interested in training and releasing your own model?</div>
                <div className={classes.modeDescription}>Send us an email to <a href='mailto:contact@sessionloops.com?subject=Train%20and%20Release%20a%20Model'>contact@sessionloops.com</a> to discuss in details</div>
            </div> */}
        </div>
        <Footer />
      </div>
  }

  export default VocalNet
